<template>
  <div class="qb-sync-badge">
    <component :is="url ? 'a' : 'div'" :href="url" target="_blank">
      <QbLogoSyncedImg v-if="synced" class="logo" />
    </component>
  </div>
</template>

<script lang="ts" setup>
import QbLogoSyncedImg from "./qb-logo-synced.svg?component";

defineProps({
  url: {
    type: String,
    default: null
  },
  synced: {
    type: Boolean,
    default: true
  }
});
</script>

<style lang="scss" scoped>
.logo {
  height: 20px;
}
</style>
